'use client';

import dynamic from 'next/dynamic';
import ModelsOfWorking from '@/components/technologies/models-of-working';
import AppstoreOptimizeServices from '@/components/technologies/appstore-optimize-services';
import CaseStudies from '@/components/common/case-study-section';
import ClientTestimonials from '@/components/home/client-testimonials';
import WhyChooseUs from '@/components/technologies/why-choose-us';
import HireProcess from '@/components/technologies/hire-process';
import DefaultBreadcrumb from '@/components/common/breadcrumbs';
import ContetImageSection from '@/components/common/content-image';
import MetaTags from '@/components/meta-tag/meta-tag';
import Blog from '@/components/home/blog';
const ContactInfo = dynamic(() => import('@/components/common/contact-info'));
const ContactForm = dynamic(() => import('@/components/common/contact-form'));

const TechHeroApp = dynamic(() => import('@/components/technologies/tech-hero-app'));
const Page = () => {
    return (
        <>
            <MetaTags />
            <TechHeroApp
                className=""
                desc="Get Your Application Ranked & Stay Tall Amongst Your Competitor With Our Premium App Store Optimization Services!"
                alt="hero image"
                title="hero image"
                width={589}
                height={550}
                path={'aso-hero'}
                bgPath={'hero-bg-grunge'}
            >
                App Store Optimization <div>Services</div>
            </TechHeroApp>
            <DefaultBreadcrumb parentPage="Services" isParent={true} currentPage="App Store Optimization Services" />
            <ContetImageSection title="Complete App Store Optimization Solution under One Roof">
                <>
                    <p className="fw-400 text-secondary fs-md">
                        Aren’t getting enough downloads? Sweating hard to enhance your application visibility worldwide?
                    </p>
                    <p className="fw-400 text-secondary fs-md mb-0">
                        Our app marketing team provides best optimization services for your application. Now boost your download
                        rates and rank high on the App Store and Play Store with our premium application optimization services.
                    </p>
                </>
            </ContetImageSection>
            <AppstoreOptimizeServices title="How Can Our Digital Marketers Optimize Your App Store Listing?" />

            <HireProcess
                white={true}
                bg="bg-primary"
                pageTitle="Hire ASO Expert To Build Cutting-Edge Digital Products"
                desc="Get a free consultation from our experts who will brainstorm your project idea to convert it into an advanced digital product using ASO."
            />
            <WhyChooseUs pageTitle="Why Choose Moweb For ASO Services?" />
            <ModelsOfWorking
                title="Engagement Models To Hire The Best ASO Expert"
                desc="Select from different engagement models to hire ASO Expert for your business needs. Different types of engagements allow you to find an optimal match for your company’s specific needs; whether that means hiring expert developers, or being flexible enough to change when necessary."
            />
            <CaseStudies />
            <section className="">
                <ClientTestimonials />
            </section>
            <Blog />
            <div className="section bg-primary py-100 dark:text-light dark:bg-black">
                <div className="container lg:container md:mx-auto">
                    <div className="row grid md:grid-cols-12 lg:grid-cols-12">
                        <ContactForm />
                        <ContactInfo />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Page;
